<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{ form.main.cv_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="cv_date">
            <label class="weui-form-preview__label">{{
              customLabel.cv_date || "拜访日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.cv_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="cv_custname">
            <label class="weui-form-preview__label">{{
              customLabel.cv_custname || "客户名称"
            }}</label>
            <span
              class="weui-form-preview__value"
              :class="{
                'weui-form-preview__value-icon': !!form.main.cv_custname,
              }"
            >
              {{ form.main.cv_custname }}
              <router-link
                v-if="form.main.cv_custname"
                class="iconfont icon-user"
                :to="'/document/customer/' + form.main.cv_custid"
              ></router-link>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cv_contect">
            <label class="weui-form-preview__label">{{
              customLabel.cv_contect || "被访人"
            }}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
            >
              {{ form.main.cv_contect }} {{ form.main.cv_tel }}
              <call-mobile :mobile="form.main.cv_tel"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="cv_position">
            <label class="weui-form-preview__label">{{
              customLabel.cv_position || "被访人职务"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.cv_position
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="cv_tel">
            <label class="weui-form-preview__label">{{
              customLabel.cv_tel || "被访人电话"
            }}</label>
            <span class="weui-form-preview__value">{{ form.main.cv_tel }}</span>
          </div>
          <div class="weui-form-preview__item" slot="cv_nextdate">
            <label class="weui-form-preview__label">{{
              customLabel.cv_nextdate || "下次拜访日期"
            }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.cv_nextdate
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.cv_vendname"
            slot="cv_vendname"
          >
            <label class="weui-form-preview__label">{{
              customLabel.cv_vendname || "开放给原厂"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.cv_vendname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="creatorName">
            <label class="weui-form-preview__label">{{
              customLabel.creatorName || "拜访人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
        </custom-layout>
      </div>
      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items1"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.cvd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="cvd_brand">
              <label class="weui-form-preview__label">{{
                customLabel.cvd_brand || "厂家/品牌"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cvd_brand }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cvd_orispeccode">
              <label class="weui-form-preview__label">{{
                customLabel.cvd_orispeccode || "型号"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cvd_orispeccode }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cvd_businessstauts">
              <label class="weui-form-preview__label">{{
                customLabel.cvd_businessstauts || "状态"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cvd_businessstauts }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cvd_projectname">
              <label class="weui-form-preview__label">{{
                customLabel.cvd_projectname || "客户项目名称"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cvd_projectname }}
              </span>
            </div>
            <custom-field
              :readOnly="true"
              :label="customLabel.cvd_text1 || '自定义字段1'"
              v-model="item.cvd_text1"
              slot="cvd_text1"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.cvd_text2 || '自定义字段2'"
              v-model="item.cvd_text2"
              slot="cvd_text2"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.cvd_text3 || '自定义字段3'"
              v-model="item.cvd_text3"
              slot="cvd_text3"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.cvd_text4 || '自定义字段4'"
              v-model="item.cvd_text4"
              slot="cvd_text4"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.cvd_text5 || '自定义字段5'"
              v-model="item.cvd_text5"
              slot="cvd_text5"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.cvd_text6 || '自定义字段6'"
              v-model="item.cvd_text6"
              slot="cvd_text6"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.cvd_text7 || '自定义字段7'"
              v-model="item.cvd_text7"
              slot="cvd_text7"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.cvd_text8 || '自定义字段8'"
              v-model="item.cvd_text8"
              slot="cvd_text8"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.cvd_text9 || '自定义字段9'"
              v-model="item.cvd_text9"
              slot="cvd_text9"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.cvd_text10 || '自定义字段10'"
              v-model="item.cvd_text10"
              slot="cvd_text10"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.cvd_text11 || '自定义字段11'"
              v-model="item.cvd_text11"
              slot="cvd_text11"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.cvd_text12 || '自定义字段12'"
              v-model="item.cvd_text12"
              slot="cvd_text12"
              hidden="true"
            />
          </custom-layout>
        </div>
      </div>
      <custom-layout :view-config="customViewConfig">
        <div
          class="form-preview weui-form-preview"
          v-show="form.main.cv_remark"
          slot="cv_remark"
        >
          <div class="weui-panel__hd">
            {{ customLabel.creatorName || "访问记录" }}
          </div>
          <div class="weui-form-preview__bd">
            <div class="form-preview__html" v-html="form.main.cv_remark"></div>
          </div>
        </div>
      </custom-layout>

      <file-list v-model="form.main.cv_attach" />

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd visit-record-reply">
          <p>拜访记录回复</p>
          <p
            class="text-link"
            v-if="
              form.main.cv_statuscode == 'AUDITED' ||
              form.main.cv_statuscode == 'SUBMITTED'
            "
            @click="open('new')"
          >
            写评论
          </p>
        </div>
        <div
          class="weui-form-preview__bd"
          v-for="(item, index) in form.items2"
          :key="item.id"
        >
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="creatorName">
              <label class="weui-form-preview__label">姓名</label>
              <p class="weui-form-preview__value">{{ item.creatorName }}</p>
            </div>
            <div class="weui-form-preview__item" slot="cr_emname">
              <label class="weui-form-preview__label">回复对象</label>
              <p class="weui-form-preview__value">{{ item.cr_emname }}</p>
            </div>
            <div class="weui-form-preview__item" slot="cr_context">
              <label class="weui-form-preview__label">回复内容</label>
              <p class="weui-form-preview__value">{{ item.cr_context }}</p>
            </div>
            <div class="weui-form-preview__item" slot="createTime">
              <label class="weui-form-preview__label">回复时间</label>
              <p class="weui-form-preview__value">{{ item.createTime }}</p>
            </div>
          </custom-layout>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label"></label>
            <p
              class="weui-form-preview__value text-link"
              @click="open('reply', index)"
            >
              回复<span class="iconfont icon-editor"></span>
            </p>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-panel__hd visit-record-reply">
          <p>拜访历史</p>
        </div>
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in history"
          :key="item.id"
        >
          <custom-layout :view-config="customViewConfig" position="detail3">
            <div class="weui-form-preview__item" slot="cv_code">
              <label class="weui-form-preview__label">{{
                customLabel.cv_code || "单据编号"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cv_code }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_date">
              <label class="weui-form-preview__label">{{
                customLabel.cv_date || "拜访日期"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon" v-format="'yyyy-MM-dd'"
                >{{ item.cv_date }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="creatorName">
              <label class="weui-form-preview__label">{{
                customLabel.creatorName || "访问人"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.creatorName }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="dp_name">
              <label class="weui-form-preview__label">{{
                customLabel.dp_name || "部门"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.dp_name }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_contect">
              <label class="weui-form-preview__label">{{
                customLabel.cv_contect || "被访人"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cv_contect }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_position">
              <label class="weui-form-preview__label">{{
                customLabel.cv_position || "被访人职务"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cv_position }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_tel">
              <label class="weui-form-preview__label">{{
                customLabel.cv_tel || "被访人电话"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cv_tel }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_nextdate">
              <label class="weui-form-preview__label">{{
                customLabel.cv_nextdate || "下次拜访日期"
              }}</label>
              <span  v-if="item.cv_nextdate"
                class="weui-form-preview__value weui-form-preview__value-icon" v-format="'yyyy-MM-dd'"
                >{{ item.cv_nextdate }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_useprod">
              <label class="weui-form-preview__label">{{
                customLabel.cv_useprod || "拜访目的"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cv_useprod }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_vendname">
              <label class="weui-form-preview__label">{{
                customLabel.cv_vendname || "开放给原厂"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cv_vendname }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cv_remark">
              <label class="weui-form-preview__label">{{
                customLabel.cv_remark || "访问记录"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cv_remark }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cvd_detno">
              <label class="weui-form-preview__label">{{
                customLabel.cvd_detno || "序号"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cvd_detno }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cvd_brand">
              <label class="weui-form-preview__label">{{
                customLabel.cvd_brand || "品牌"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cvd_brand }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cvd_orispeccode">
              <label class="weui-form-preview__label">{{
                customLabel.cvd_orispeccode || "型号"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cvd_orispeccode }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cvd_businessstauts">
              <label class="weui-form-preview__label">{{
                customLabel.cvd_businessstauts || "状态"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cvd_businessstauts }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="cvd_projectname">
              <label class="weui-form-preview__label">{{
                customLabel.cvd_projectname || "客户项目名称"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.cvd_projectname }}
              </span>
            </div>
          </custom-layout>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/crm/client_visit_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
      <share
        class="weui-dialog__btn weui-dialog__btn_default"
        v-if="!editable"
        :biz-data="bizData"
      ></share>
    </div>

    <div v-if="showReply">
      <div class="weui-mask weui-transition"></div>
      <div class="weui-half-screen-dialog weui-transition">
        <div class="weui-half-screen-dialog__hd">
          <div class="weui-half-screen-dialog__hd__main">
            <div class="weui-half-screen-dialog__title">写评论</div>
            <div class="weui-half-screen-dialog__subtitle">{{ subtitle }}</div>
          </div>
        </div>
        <div
          class="weui-half-screen-dialog__bd"
          style="padding-top: 12px; height: 150px"
        >
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              rows="5"
              autofocus
              v-model="cr_context"
              placeholder="请填写......"
              placeholder-class="weui-input__placeholder"
            />
          </div>
        </div>
        <div class="weui-half-screen-dialog__ft">
          <div class="weui-half-screen-dialog__btn-area">
            <div class="weui-btn weui-btn_primary" @click="reply">回复</div>
            <div class="weui-btn weui-btn_default" @click="cancel">取消</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";
import Share from "@/components/button/Share.vue";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    CallMobile,
    FileList,
    Share,
    CustomField,
  },
  data() {
    return {
      baseUrl: "/api/crm/clientvisit",
      codeField: "cv_code",
      statusField: "cv_statuscode",
      caller: "ClientVisit",
      xtype: "crm-clientvisit-formpanel",
      cr_context: "",
      showReply: false,
      id: 0,
      subtitle: "",
      form: {
        main: {},
        items1: [], // 默认值
        items2: [],
      },
      history: [],
    };
  },
  computed: {
    bizData() {
      var main = this.form.main;
      if (!main) {
        return null;
      }
      return {
        bizCode: main.cv_code,
        bizType: "ClientVisit",
        bizId: main.id,
        viewType: "crm-clientvisit-formpanel",
        title: "客户拜访" + main.cv_code,
      };
    },
  },

  methods: {
    getHistory() {
      let me = this,
        main = me.form.main;
       
      let params = {
        cv_custname: main.cv_custname,
        creatorId: main.creatorId,
      };
      me.$ajax({
        url: "/api/crm/clientvisit/listByCu",
        params,
      }).then(function (res) {
        if (res.success) {
          me.history = res.data.details2;
        }
      });
    },
  
    f_afterload() {
      this.getHistory();
    },
    open(type, index) {
      if (type == "new") {
        this.subtitle = "新评论";
        this.id = 0;
      } else {
        let creatorName = this.form.items2[index].creatorName;
        this.subtitle = "回复：" + creatorName;
        this.id = this.form.items2[index].id;
      }
      this.showReply = true;
    },
    reply() {
      let me = this;
      let cr_context = me.cr_context;
      let id = me.id;
      let cr_cvid = me.form.main.id;
      if (!cr_context) {
        me.$weui.topTips("请填写回复内容 ", 1000);
        return;
      }
      me.$loading({
        url: "/api/crm/clientvisit/reply",
        jsonData: {
          cr_context,
          id,
          cr_cvid,
        },
        method: "POST",
      }).then(function (res) {
        if (res.success) {
          me.showReply = false;
          me.cr_context = "";
          me.$weui.toast("回复成功", 1000);
          setTimeout(() => {
            me.f_get();
          }, 1000);
        } else {
          me.$weui.topTips("回复失败", 1000);
        }
      });
    },
    cancel() {
      this.showReply = false;
    },
  },
};
</script>

<style scoped>
.visit-record-reply {
  display: flex;
  justify-content: space-between;
}

.weui-btn:nth-last-child(n + 2),
.weui-half-screen-dialog__ft .weui-btn:nth-last-child(n + 2) + .weui-btn {
  display: inline-block;
  vertical-align: top;
  margin: 0 8px;
  width: 100px;
}
</style>